module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Bag1-91fa89c013777d964c8aa0011dc98b47.svg";